import React from 'react';
import './About.css';

const About: React.FC = () => {
  return (
    <div className="about-page">
      <section className="about-hero">
        <div className="container">
          <h1 className="page-title">Hakkımızda</h1>
          <p className="page-subtitle">
            Prefabrik yapı sektöründe yılların deneyimi ve modern teknoloji ile 
            hizmet veren güvenilir bir firmayız.
          </p>
        </div>
      </section>

      <section className="about-content section">
        <div className="container">
          <div className="about-grid">
            <div className="about-text">
              <h2 className="content-title">Firmamız Hakkında</h2>
              <p className="content-paragraph">
                Prefabrik yapı sektöründe uzun yıllardır faaliyet gösteren firmamız, 
                müşterilerimize en kaliteli ve modern yapı çözümlerini sunmaktadır. 
                Deneyimli ekibimiz ve teknolojik altyapımız sayesinde, her türlü 
                prefabrik yapı ihtiyacınıza profesyonel çözümler üretiyoruz.
              </p>
              <p className="content-paragraph">
                Müşteri memnuniyetini ön planda tutan anlayışımız, kaliteli 
                malzeme kullanımı ve zamanında teslimat prensiplerimiz ile 
                sektörde öncü konumdayız. Her projeyi özenle ele alıyor, 
                müşterilerimizin hayallerini gerçeğe dönüştürüyoruz.
              </p>
            </div>
            <div className="about-image">
              <img src="/images/about-1.jpeg" alt="Hakkımızda" loading="lazy" />
            </div>
          </div>
        </div>
      </section>

      <section className="values-section section">
        <div className="container">
          <h2 className="section-title">Değerlerimiz</h2>
          <div className="values-grid">
            <div className="value-card">
              <h3 className="value-title">Kalite</h3>
              <p className="value-description">
                En yüksek kalite standartlarında malzeme ve işçilik ile 
                uzun ömürlü yapılar üretiyoruz.
              </p>
            </div>
            <div className="value-card">
              <h3 className="value-title">Güvenilirlik</h3>
              <p className="value-description">
                Söz verdiğimiz tarihte teslimat, şeffaf fiyatlandırma ve 
                güvenilir hizmet anlayışı.
              </p>
            </div>
            <div className="value-card">
              <h3 className="value-title">İnovasyon</h3>
              <p className="value-description">
                Modern teknoloji ve yenilikçi tasarımlarla sektörde 
                öncü çözümler sunuyoruz.
              </p>
            </div>
            <div className="value-card">
              <h3 className="value-title">Müşteri Odaklılık</h3>
              <p className="value-description">
                Her müşterimizin ihtiyacına özel çözümler üretiyor, 
                memnuniyeti ön planda tutuyoruz.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="stats-section">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-item">
              <div className="stat-number">500+</div>
              <div className="stat-label">Tamamlanan Proje</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">15+</div>
              <div className="stat-label">Yıllık Deneyim</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">1000+</div>
              <div className="stat-label">Mutlu Müşteri</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">%98</div>
              <div className="stat-label">Müşteri Memnuniyeti</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;

